import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

interface NewDeviceTagProps {
  hideLabel?: boolean;
  size?: 'xs' | 'sm' | 'md';
  width?: string;
}

const NewDeviceTag = ({ hideLabel = false, size = 'md', width }: NewDeviceTagProps) => {
  const sizeClass = {
    xs: 'px-1.5 py-1 text-[10px] [&>svg]:!size-3',
    sm: 'px-2.5 py-1 text-xs',
    md: 'px-2.5 py-1',
  };

  const iconSize = {
    xs: '!size-3',
    sm: '!size-3',
    md: '!size-4',
  };

  return (
    <div className={cn('flex items-center justify-center gap-1 rounded-3xl bg-success-3 text-success', sizeClass[size], width || 'w-fit')}>
      <Icon name='badge-alert' className={iconSize[size]} />
      {!hideLabel && 'novo dispositivo'}
    </div>
  );
};

export default NewDeviceTag;
